import { Grade } from '@vendasta/snapshot';

export function gradeToLetter(grade?: number): string {
  return grade > 0 ? Grade[grade] : '-';
}
